import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Const from '../Const';
import Create from '../summary/Create';
import OrganizeColumnIndex from './OrganizeColumnIndex';
import { fetchCoveredWarrant } from './reducer';
import { REDUCER_NAME as WL_REDUCER } from '../reducer';
import TableCoveredWarrant from './TableCoveredWarrant';
import './covered-warrant.scss';
import LockedDiv from '../../../common/locked-div/LockedDiv';

class CoveredWarrant extends PureComponent {
  componentDidMount() {
    this.getCoveredWarrants();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentCoveredWarrant, locale } = this.props;
    if (
      currentCoveredWarrant !== prevProps.currentCoveredWarrant ||
      locale !== prevProps.locale
    ) {
      this.getCoveredWarrants();
    }
  }

  getCoveredWarrants = () => {
    const { fetchCoveredWarrant, currentCoveredWarrant } = this.props;
    fetchCoveredWarrant(currentCoveredWarrant);
  };

  renderRight = () => {
    return (
      <div className="d-flex justify-content-end pr-10">
        <LockedDiv>
          <Create type={Const.watchListType.CUSTOM_CW} />
        </LockedDiv>
        <OrganizeColumnIndex />
      </div>
    );
  };

  render() {
    return (
      <div className="d-flex flex-column flex-fill covered-warrant-wrap">
        {this.renderRight()}

        <div className="covered-warrant-data pl-20 pr-10 mt-10 flex-fill d-flex flex-column">
          <TableCoveredWarrant />
        </div>
      </div>
    );
  }
}

CoveredWarrant.propTypes = {};

const mapStateToProps = state => ({
  currentCoveredWarrant: state[WL_REDUCER].currentCoveredWarrant,
  locale: state.i18n.locale,
  user: state.userInfo,
});
const mapDispatchToProps = {
  fetchCoveredWarrant,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CoveredWarrant);
